import React from 'react';
import { observer } from 'mobx-react';
import Avatar from '../Base/User/Avatar';
import ChatOutlinedIcon from '@material-ui/icons/ChatOutlined';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew';
import { USER_STATES } from '../../constants';
import { useStore } from '../../store/rootStore';
import { Trans } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Button } from 'antd';
import MobileTopBar from '../MainPage/TopContent/atoms/MobileTopBar';
import placeholderAvatar from '../../assets/avatars/placeholder-avatar.png';
import styles from './TopMobileDrawer.module.scss';
const TopMobileDrawer = ({ toggleMessageDrawer, toggleDrawer }) => {
    var _a, _b;
    const { loginStore, statusStore } = useStore();
    const history = useHistory();
    function logOut() {
        loginStore.logOut().then(() => {
            if (loginStore.userState === USER_STATES.LOGGED_OUT) {
                history.push('/login');
            }
        });
    }
    return (React.createElement("div", { className: styles.mobileMenu },
        React.createElement(MobileTopBar, { className: styles.mobileMenuTopBar }),
        React.createElement("div", { className: styles.mobileMenuProfile },
            React.createElement(Avatar, { displayName: ((_a = loginStore.userDetails) === null || _a === void 0 ? void 0 : _a.displayName) || '', src: placeholderAvatar, status: statusStore.status, uiAvatarProps: {
                    className: styles.mobileMenuAvatar,
                } }),
            React.createElement("div", null, (_b = loginStore.userDetails) === null || _b === void 0 ? void 0 : _b.displayName)),
        React.createElement("div", { className: styles.mobileMenuButtons },
            React.createElement("div", { className: styles.mobileMenuButton, onClick: toggleMessageDrawer },
                React.createElement(Button, null,
                    React.createElement(ChatOutlinedIcon, { className: styles.menuButtonColor })),
                React.createElement(Trans, { i18nKey: "sendNewMessage" })),
            React.createElement("div", { onClick: toggleDrawer, className: styles.mobileMenuButton },
                React.createElement(Button, null,
                    React.createElement(SettingsOutlinedIcon, { className: styles.menuButtonColor })),
                React.createElement(Trans, { i18nKey: "Settings" })),
            React.createElement("div", { className: styles.mobileMenuButton }),
            React.createElement("div", { onClick: logOut, className: styles.mobileMenuButton },
                React.createElement(Button, { size: "large", type: "ghost" },
                    React.createElement(PowerSettingsNewIcon, { className: styles.menuButtonColor })),
                React.createElement(Trans, { i18nKey: "logout" })))));
};
export default observer(TopMobileDrawer);
